<template>
    <div id="app">
        <div id="page-wrapper">
            <navbar></navbar>
            <nprogress-container></nprogress-container>
            <progress class="progress is-small is-primary" max="100">15%</progress>


            <app-main></app-main>
        </div>
        <footer-bar></footer-bar>
    </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import NprogressContainer from 'vue-nprogress/src/NprogressContainer';
import { Navbar, AppMain, FooterBar } from './components/layout/';
import './style/app.scss';

export default {
    components: {
        Navbar,
        AppMain,
        FooterBar,
        NprogressContainer
    },

    computed: {

    },

    methods: {

    },

    created() {

    }

};
</script>




// WEBPACK FOOTER //
// src/App.vue